import React, { useCallback, useEffect, useState } from 'react';
import api from '../services/api';
import usePullToRefresh from '../hooks/usePullToRefresh';

const DashboardPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(() => {
    setLoading(true);
    api
      .get('/api/protected/data')
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  usePullToRefresh(fetchData);

  return (
    <div>
      <h1>Dashboard</h1>
      {loading ? (
        <>
          <section className="profile-header">
            <div className="skeleton skeleton-avatar" />
            <div className="profile-header__text">
              <div className="skeleton skeleton-line skeleton-line--wide" />
              <div className="skeleton skeleton-line" />
            </div>
          </section>
          <section className="card-grid">
            <div className="skeleton skeleton-card" />
            <div className="skeleton skeleton-card" />
            <div className="skeleton skeleton-card" />
          </section>
          <section className="table-skeleton">
            <div className="skeleton skeleton-line skeleton-line--wide" />
            <div className="skeleton skeleton-line" />
            <div className="skeleton skeleton-line" />
            <div className="skeleton skeleton-line skeleton-line--wide" />
          </section>
        </>
      ) : (
        <pre>{JSON.stringify(data, null, 2)}</pre>
      )}
    </div>
  );
};

export default DashboardPage;
